var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1497 39.3882L29.7939 29.8333L40.1497 20.2785C40.3968 20.0505 40.5928 19.7798 40.7265 19.4819C40.8603 19.1841 40.9291 18.8648 40.9291 18.5424C40.9291 18.2199 40.8603 17.9007 40.7265 17.6028C40.5928 17.3049 40.3968 17.0342 40.1497 16.8062C39.9026 16.5782 39.6092 16.3974 39.2864 16.274C38.9635 16.1506 38.6175 16.0871 38.268 16.0871C37.9186 16.0871 37.5725 16.1506 37.2497 16.274C36.9268 16.3974 36.6335 16.5782 36.3864 16.8062L24.1356 28.1095C23.8882 28.3373 23.6919 28.6079 23.558 28.9059C23.424 29.2038 23.3551 29.5231 23.3551 29.8456C23.3551 30.1682 23.424 30.4875 23.558 30.7854C23.6919 31.0833 23.8882 31.3539 24.1356 31.5818L36.3864 42.8851C37.4273 43.8455 39.1088 43.8455 40.1497 42.8851C41.1639 41.9246 41.1906 40.3486 40.1497 39.3882Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2898daeedb2818f1842ca2a711a770ce.svg";
export { ForwardRef as ReactComponent };